import api from '../api.js'
import store from '../../store'
import utility from '../utility'

export default {
    get_fatture(search) {
        const _search = utility.appendParameters(search);
        return api.get(`/v2/bonifici/fatture?token=${store.getters.access_token}&${_search}`);
    },
    download_xml(data) {
        return api.post(`/v2/bonifici/download-xml?token=${store.getters.access_token}`, data, {
            responseType: 'blob'
        });
    },
    send_email(data) {
        return api.post(`/v2/bonifici/send-email?token=${store.getters.access_token}`, data);
    }
};
